/* global axios */
import { getAccountIdFromLocation } from 'dashboard/helper/browserNavigation';

const DEFAULT_API_VERSION = 'v1';

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    return getAccountIdFromLocation();
  }

  baseUrl() {
    let url = this.apiVersion;

    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}`;
    }

    return url;
  }

  get(path = '', config = {}) {
    return axios.get(`${this.url}${path ? `/${path}` : ''}`, config);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data, config = {}) {
    return axios.post(this.url, data, config);
  }

  post(path, data) {
    return axios.post(`${this.url}/${path}`, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default ApiClient;
